"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Prebinding_1 = require("../Prebinding");
var Context_1 = require("../Context");
var ElementWithContextInitializer = (function () {
    function ElementWithContextInitializer() {
    }
    ElementWithContextInitializer.initializeContextWithinElement = function (element) {
        if (!!Context_1.Context.element) {
            element.appendChild(Context_1.Context.element.cloneNode(true));
        }
        Prebinding_1.Prebinding.applyPrebindingOnElement(element);
        Prebinding_1.Prebinding.applyPrebindingOnChildren(element);
    };
    return ElementWithContextInitializer;
}());
exports.ElementWithContextInitializer = ElementWithContextInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/base/initialization/ElementWithContextInitializer.ts
// module id = 8
// module chunks = 13 14